import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { ISearchFilterDetails } from '@api/types'
interface Payload {
  data: {
    viewer: {
      company: ISearchFilterDetails
    }
  }
}
const getSearchFilterDetails = async () => {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: { company },
      },
    }: Payload) => company
  )
}

export default getSearchFilterDetails

const query = gql`
  query searchFilterDetails {
    viewer {
      company {
        employeeConnection {
          counters {
            total
          }
        }
        departmentConnection {
          counters {
            total
          }
        }
        spaceConnection {
          counters {
            total
          }
        }
        neighborhoodConnection {
          counters {
            total
          }
        }
      }
    }
  }
`
